/**
 * How visible KPI tiles are ordered on Business and custom tabs.
 */

import React from 'react';
import { TILE_SORTS, type TileSort } from './types';

interface SortControlsProps {
  sort: TileSort;
  saving: boolean;
  onChange: (sort: TileSort) => void;
  t: (key: string) => string;
}

const LABEL: Record<TileSort, { key: string; fallback: string }> = {
  default: { key: 'kpi.perfSortDefault', fallback: 'Pick order' },
  name: { key: 'kpi.perfSortName', fallback: 'Name' },
  unfavorable: { key: 'kpi.perfSortUnfavorable', fallback: 'Unfavorable' }
};

export const SortControls: React.FC<SortControlsProps> = ({ sort, saving, onChange, t }) => (
  <div className="mb-2">
    <p className="text-[10px] text-[var(--color-secondary-text)] mb-0.5">
      {t('kpi.perfSortLabel') || 'Sort tiles'}
    </p>
    <div className="flex flex-wrap gap-x-2 gap-y-0.5">
      {TILE_SORTS.map((value) => (
        <label
          key={value}
          className="flex items-center gap-1 text-[11px] text-[var(--color-surface-text)] cursor-pointer"
        >
          <input
            type="radio"
            name="kpi-tile-sort"
            className="mt-0"
            disabled={saving}
            checked={sort === value}
            onChange={() => onChange(value)}
          />
          <span className="leading-tight">{t(LABEL[value].key) || LABEL[value].fallback}</span>
        </label>
      ))}
    </div>
  </div>
);
